import { useState } from 'react'

export default function useSyntheticVoice() {
  const [syntheticVoiceState, setState] = useState({
    isLoading: false,
  });
  
  const scriptToVoice = async (voiceId, text) => {
    setState({
      isLoading: true,
    });

    const response = await fetch('/rest/v2/syntheticvoice/script-to-voice', {
      method: 'POST',
      body: JSON.stringify({
        voiceId,
        text
      }),
    });
    const result = await response.json();

    setState({
      isLoading: false,
    });

    if (result.success === false) {
      console.error(result.errors);
      return null;
    }

    return result['data']['url'];
  }

  return [syntheticVoiceState, scriptToVoice]
}
